<div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium">HHG Add Rates</legend>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="isErrorMessages">
        <div class="usa-alert usa-alert--error usa-alert--no-icon">
            <div class="usa-alert__body" *ngFor="let error  of errorMessages">
                <p class="usa-alert__text" *ngIf="error.errorType !== 'WARNING'">
                    {{error.errorMessage}}
                </p>
            </div>
        </div>
    </div>
</div>
<form [formGroup]="hhgCarrierRates">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label class="usa-label" for="transport_type">Transport Type<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
            <select id="transport_type" class="usa-select maxw-full" formControlName="transportType" (change)="transportTypeChange()" required>
                <option value="" selected>Choose...</option>
                <option [ngValue]="tst" *ngFor="let tst of transportTypes">{{tst}}</option>
            </select>
            <div *ngIf="showIntrastateMessage" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Alaskan points are not allowed for Intrastate, please use Interstate
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label class="usa-label" for="rate_type">Rate Type<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
            <select id="rate_type" class="maxw-full usa-select" formControlName="rateTypeId" (change)="rateTypeChange()" required>
                <option value="" selected>Choose...</option>
                <option [ngValue]="rate.legacyRateType" *ngFor="let rate of rateTypesByTransport">
                    {{rate.legacyRateType}} -
                    {{rate.description}}</option>
            </select>
            <div *ngIf="rateTypeError" class="define-text-secondary">
                <div *ngFor="let error of rateTypeErrorMessage">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> {{error}}
                </div>
            </div>
            <div *ngIf="this.messageForMCAndFF!==''" class="text-accent-warm">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                  </svg> {{this.messageForMCAndFF}}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label class="usa-label" for="agency_id">SRO ID<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
            <select id="agency_id" class="maxw-full usa-select" required formControlName="sroMasterId" (change)="agencyTypeChange()">
                <option value="" selected disabled>Choose...</option>
                <option [ngValue]="agency" *ngFor="let agency of agenciesByRateType">{{agency.sroId}}</option>
            </select>
            <div *ngIf="agencyError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ agencyErrorMessage }}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="tender_id" class="usa-label">Tender ID<abbr title="required"
                class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" oninput="this.value = this.value.toUpperCase()" [minLength]="4" [maxLength]="4" id="tender_id" class="maxw-full usa-input" formControlName="tenderId" required>
            <span class="text-base">Tender ID must be four characters.</span>
            <div *ngIf="this.hhgCarrierRates.get('tenderId').invalid && (this.hhgCarrierRates.get('tenderId').touched
                || this.hhgCarrierRates.get('tenderId').dirty)" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Tender ID is required & must be four characters
            </div>
        </div>
    </div>

    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
            <h5 class="text-semibold">Route</h5>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label class="usa-label" for="route_origin">Origin<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <select id="route_origin" class="maxw-full usa-select" required formControlName="originId" (change)="originTypeChange()">
                <option value="" selected disabled>Choose...</option>
                <option [ngValue]="origin" *ngFor="let origin of originByType">{{origin.stateCountryCode}} - {{origin.stateCountryName}}</option>
            </select>
            <div *ngIf="originError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ originErrorMessage }}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDestination">
            <label for="route_destination" class="usa-label">Destination<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <select id="route_destination" required class="maxw-full usa-select" formControlName="destinationId" (change)="destinationTypeChange()">
                <option value="" selected disabled>Choose...</option>
                <option [ngValue]="dest" *ngFor="let dest of destinationByType">
                    <ng-container *ngIf="this.showCode">
                        {{dest.stateCountryCode}} - {{dest.stateCountryName}}
                    </ng-container>
                    <ng-container *ngIf="!this.showCode">
                        {{dest.stateCountryCode}} - {{dest.stateCountryName}}
                    </ng-container></option>
            </select>
            <div *ngIf="destinationError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ destinationErrorMessage }}
            </div>
            <div *ngIf="destinationProcureError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ destinationProcureErrorMessage }}
            </div>
        </div>
    </div>

    <div class="grid-row grid-gap-1" *ngIf="showDiscountFieldsByTransport || showXtosTransportTypeText || showDiscountFieldsByRate">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12  padding-top-4" *ngIf="showDiscountFieldsByTransport">
            <h5 class="text-semibold">Discounts</h5>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="showXtosTransportTypeText">
            <div class="usa-alert usa-alert--warning usa-alert--no-icon">
                <div class="usa-alert__body">
                    <p class="usa-alert__text">
                        When entering the below charges, do not enter decimals. For example: 550 ($5.50); 2560 ($25.60); 12500 ($125.00).
                    </p>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByRate">
            <label for="packaging_discount" class="usa-label">Packaging/Loading/Drayage <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="packaging_discount" required class="usa-input maxw-full" [maxlength]="packagingMaxLength" appNumbersOnly formControlName="classVehicle1" (input)="packagingDiscountValueChange($event.target.value, 'packaging')">
            <div *ngIf="packagingDiscountError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ packagingDiscountErrorMessage }}
            </div>
            <div *ngIf="packagingDiscountWarning" class="text-accent-warm">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                </svg> {{ packagingDiscountWarningMessage }}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByRate">
            <label for="warehouse_discount" class="usa-label">Warehouse Handling <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="warehouse_discount" required class="maxw-full usa-input" [maxlength]="packagingMaxLength" appNumbersOnly formControlName="classVehicle2" (input)="packagingDiscountValueChange($event.target.value, 'warehouse')">
            <div *ngIf="wareHouseError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ wareHouseErrorMessage }}
            </div>
            <div *ngIf="wareHouseWarning" class="text-accent-warm">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                </svg> {{ wareHouseWarningMessage }}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByRate">
            <label for="storage_discount" class="usa-label">Monthly Storage <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="storage_discount" required class="maxw-full usa-input" appNumbersOnly [maxlength]="packagingMaxLength" formControlName="classVehicle3" (input)="packagingDiscountValueChange($event.target.value, 'storage')">
            <div *ngIf="monthlyStorageError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>{{ monthlyStorageErrorMessage }}
            </div>
            <div *ngIf="monthlyStorageWarning" class="text-accent-warm">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                </svg>{{ monthlyStorageWarningMessage }}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByRate">
            <label for="delivery_50mile_discount" class="usa-label">Delivery Within 50 Miles <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="delivery_50mile_discount" required appNumbersOnly class="maxw-full usa-input" [maxlength]="deliveryMaxLength" formControlName="storageInTransit" (input)="onDiscountFieldsChange($event.target.value, 'delivery50Mile')">
<!--          <div *ngIf="hhgCarrierRates.get('storageInTransit').hasError('required') && this.hhgCarrierRates.get('storageInTransit').touched && this.hhgCarrierRates.get('storageInTransit').invalid" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Delivery within 50 miles charge cannot be 0 or blank.
            </div>-->
          <div *ngIf="discountFieldSitError" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> {{ discountFieldSitErrorMessage }}
          </div>
          <div *ngIf="this.hhgCarrierRates.get('storageInTransit').touched && this.hhgCarrierRates.get('storageInTransit').value < 0">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
            </svg> Suspect Record - Value Negative
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByRate">
            <label for="delivery_out_discount" class="usa-label">Delivery Handling Out <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="delivery_out_discount" required appNumbersOnly class="maxw-full usa-input" [maxlength]="deliveryMaxLength" formControlName="accessorials" (input)="onDiscountFieldsChange($event.target.value, 'deliveryHandOut')">
<!--            <div *ngIf="hhgCarrierRates.get('accessorials').hasError('required') && this.hhgCarrierRates.get('accessorials').touched && this.hhgCarrierRates.get('accessorials').invalid" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Delivery Handling Out charge cannot be 0 or blank.
            </div>-->
          <div *ngIf="discountFieldMonthlyStorageError" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> {{ discountFieldMonthlyStorageErrorMessage }}
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByTransport">
            <label for="transportation" class="usa-label">Transportation % <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="transportation" class="maxw-full usa-input" appNumbersOnly maxlength="4" formControlName="linehaul" (input)="transportationValueChange($event.target.value)">
            <div *ngIf="transportationError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ transportationErrorMessage }}
            </div>
            <div *ngIf="transportationWarning" class="text-accent-warm">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                </svg> {{ transportationWarningMessage }}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByTransport" (input)="sitValueChange($event.target.value)">
            <label for="storage-in-Transit" class="usa-label">Storage-in-Transit <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="storage-in-Transit" appNumbersOnly class="maxw-full usa-input" maxlength="4" formControlName="storageInTransit">
            <div *ngIf="sitError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ sitErrorMessage }}
            </div>
            <!--<div *ngIf="hhgCarrierRates.get('storageInTransit').hasError('required') && this.hhgCarrierRates.get('storageInTransit').touched && this.hhgCarrierRates.get('storageInTransit').invalid" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Delivery within 50 miles charge cannot be 0 or blank.
            </div>-->
          <div *ngIf="sitWarning" class="text-accent-warm">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
            </svg> {{ sitWarningMessage }}
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByTransport" (input)="accSvcsValueChange($event.target.value)">
            <label for="acc_discount" class="usa-label">Accessorial Services <abbr title="required" class="usa-hint usa-hint--required" *ngIf="isAccUabMandatory">*</abbr></label>
            <input type="text" id="acc_discount" appNumbersOnly class="maxw-full usa-input" maxlength="4" formControlName="accessorials">
            <div *ngIf="accSvcsError" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ accSvcsErrorMessage }}
            </div>
<!--            <div *ngIf="hhgCarrierRates.get('accessorials').hasError('required') && this.hhgCarrierRates.get('accessorials').touched && this.hhgCarrierRates.get('accessorials').invalid" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Delivery Handling Out charge cannot be 0 or blank.
            </div>-->
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByTransport" (input)="uabValueChange($event.target.value)">
            <label for="uab_discount" class="usa-label">Unaccompanied Air Baggage <abbr title="required" class="usa-hint usa-hint--required" *ngIf="isUabMandatory">*</abbr></label>
            <input type="text" id="uab_discount" appNumbersOnly class="maxw-full usa-input" maxlength="4" formControlName="unaccompaniedAirBag">
            <div class="define-text-secondary" *ngIf="uabError || (this.hhgCarrierRates.get('unaccompaniedAirBag').touched && this.hhgCarrierRates.get('unaccompaniedAirBag').invalid)">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{ uabErrorMessage }}
            </div>
            <div class="define-text-secondary" *ngIf="hhgCarrierRates.get('unaccompaniedAirBag').hasError('required') && this.hhgCarrierRates.get('unaccompaniedAirBag').touched && this.hhgCarrierRates.get('unaccompaniedAirBag').invalid">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Unaccompanied Air Baggage is required
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9 padding-top-4" *ngIf="showDiscountFieldsText || showDiscountFieldsAlaskaText">
                    <div class="usa-alert usa-alert--error usa-alert--no-icon bg-accent-warm define-left-border">
                        <div class="usa-alert__body">
                            <p class="usa-alert__text" *ngIf="showDiscountFieldsText">
                                Enter vehicle price per mile. Example: enter 50 for $0.50 , 250 for $2.50
                            </p>
                            <p class="usa-alert__text" *ngIf="showDiscountFieldsAlaskaText">
                                Enter flat price per vehicle. Example: enter 975 for $975, 3900 for $3,900.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByTransport">
                    <ng-container *ngIf="this.getFormField('rateTypeId').value === 16; else second">
                        <label for="cat1_vehicle" class="usa-label">Class 1: 1 - 5,999 <br> GVWR</label>
                    </ng-container>
                    <ng-template #second>
                        <ng-container *ngIf="this.getFormField('rateTypeId').value === 17; else third">
                            <label for="cat1_vehicle" class="usa-label">Class 1: 1 - 5,999 <br> GVWR</label>
                        </ng-container>
                    </ng-template>
                    <ng-template #third>
                        <label for="cat1_vehicle" class="usa-label">Category 1 Vehicle <br> ( < 300 cft )<abbr title="required" class="usa-hint usa-hint--required" *ngIf="isVehicleMandatory">*</abbr></label>
                    </ng-template>
                    <input type="text" id="cat1_vehicle" required appNumbersOnly class="maxw-full usa-input" maxlength="6" formControlName="classVehicle1" (input)="categoryVehicleValueChange($event.target.value, 'classVehicle1')">
                    <div *ngIf="categoryVehicle1Error" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> {{ categoryVehicle1ErrorMessage }}
                    </div>
                    <div *ngIf="categoryVehicle1Warning" class="text-accent-warm">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                        </svg>{{ categoryVehicle1WarningMessage }}
                    </div>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByTransport">
                    <ng-container *ngIf="this.getFormField('rateTypeId').value === 16;else second">
                        <label for="cat2_vehicle" class="usa-label">Class 2: 6,000 - 11,999 <br> GVWR</label>
                    </ng-container>
                    <ng-template #second>
                        <ng-container *ngIf="this.getFormField('rateTypeId').value === 17;else third">
                            <label for="cat2_vehicle" class="usa-label">Class 2: 6,000 - 11,999 <br> GVWR</label>
                        </ng-container>
                    </ng-template>
                    <ng-template #third>
                        <label for="cat2_vehicle" class="usa-label">Category 2 Vehicle<br>(300-800 cft)
                            <abbr title="required" class="usa-hint usa-hint--required" *ngIf="isVehicleMandatory">*</abbr></label>
                    </ng-template>
                    <input type="text" id="cat2_vehicle" required appNumbersOnly class="usa-input maxw-full" maxlength="6" formControlName="classVehicle2" (input)="categoryVehicleValueChange($event.target.value, 'classVehicle2')">
                    <div *ngIf="categoryVehicle2Error" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>{{ categoryVehicle2ErrorMessage }}
                    </div>
                    <div *ngIf="categoryVehicle2Warning" class="text-accent-warm">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                            </svg>{{ categoryVehicle2WarningMessage }}
                    </div>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showDiscountFieldsByTransport">
                    <ng-container *ngIf="this.getFormField('rateTypeId').value === 16;else second">
                        <label for="cat3_vehicle" class="usa-label">Class 3: 12,000 and Above <br> GVWR</label>
                    </ng-container>
                    <ng-template #second>
                        <ng-container *ngIf="this.getFormField('rateTypeId').value === 17;else third">
                            <label for="cat3_vehicle" class="usa-label">Class 3: 12,000 and Above <br> GVWR</label>
                        </ng-container>
                    </ng-template>
                    <ng-template #third>
                        <label for="cat3_vehicle" class="usa-label">Category 3 Vehicle<br>(> 800 cft)
                            <abbr title="required" class="usa-hint usa-hint--required" *ngIf="isVehicleMandatory">*</abbr></label>
                    </ng-template>
                    <input type="text" id="cat3_vehicle" required appNumbersOnly class="maxw-full usa-input" maxlength="6" formControlName="classVehicle3" (input)="categoryVehicleValueChange($event.target.value, 'classVehicle3')">
                    <div *ngIf="categoryVehicle3Error" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>{{ categoryVehicle3ErrorMessage }}
                    </div>
                    <div *ngIf="categoryVehicle3Warning" class="text-accent-warm">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                        </svg>{{ categoryVehicle3WarningMessage }}
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
            <h5 class="text-semibold">Contact Information</h5>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="carrier_phone" class="usa-label">Phone
                <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="carrier_phone" appNumbersOnly class="maxw-full usa-input" formControlName="bookingPhone" pattern="[0-9]*" required [maxlength]="15">
            <div *ngIf="isFieldValid('bookingPhone')" class="define-text-secondary">
                <div *ngIf="hhgCarrierRates.get('bookingPhone').hasError('minlength')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Phone number must be 10 digits
                </div>
                <div *ngIf="hhgCarrierRates.get('bookingPhone').hasError('maxlength')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Phone number can not be more than 15 digits
                </div>
                <div *ngIf="hhgCarrierRates.get('bookingPhone').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Phone number is required
                </div>
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="carrier_email" class="usa-label">Email<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="carrier_email" class="usa-input maxw-full" maxlength="45" formControlName="bookingEmail" required>
            <div *ngIf="isFieldValid('bookingEmail')" class="define-text-secondary">
                <div *ngIf="hhgCarrierRates.get('bookingEmail').hasError('email')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Enter a valid email
                </div>
                <div *ngIf="hhgCarrierRates.get('bookingEmail').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Email is required
                </div>
                <div *ngIf="hhgCarrierRates.get('bookingEmail').hasError('pattern')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Email is invalid
                </div>
            </div>
        </div>
    </div>
    <div class="grid-row padding-top-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <button type="button" class="usa-button" [disabled]="this.hhgCarrierRates.invalid || disableSave()" (click)="saveOnlineRates(hhgCarrierRates.value)">Save</button>
        </div>
    </div>
</form>
